export default __webpack_public_path__ + "static/media/icon_app_m.31b3438b.svg";